import { render, staticRenderFns } from "./WordingForm.vue?vue&type=template&id=7c60efa6&scoped=true&"
import script from "./WordingForm.vue?vue&type=script&lang=js&"
export * from "./WordingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c60efa6",
  null
  
)

export default component.exports